<template>
  <!-- {{ shareList }} -->
  <el-popover
ref="sharePopoverRef" placement="bottom-start" :width="200" :show-arrow="false" popper-class="popperClass" trigger="click" :persistent="false" :teleported="false"
    :popper-style="{
      fontFamily: 'SFPro,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif',
      border:'none'
    }">
    <template #reference>
      <slot/>
    </template>
    <div class="popoverList">
      <div v-for="(item, index) in shareList" :key="index" class="popoverItem" @click="handleCommand(item)">
        <component :is="item.icon" class="icon" />
        {{ item.title }}
      </div>
    </div>
  </el-popover>
</template>

<script setup>
const { $showToast } = useNuxtApp();
const { t } = useI18n();

const shareList = [{
  key: 'Facebook',
  title: 'Facebook',
  icon: 'icon-facebook',
  shUrl: 'https://www.facebook.com/sharer/sharer.php?u=',
},
{
  key: 'Twitter',
  title: 'Twitter',
  icon: 'icon-twitter',
  shUrl: 'https://x.com/intent/post?',
},
{
  key: 'Reddit',
  title: 'Reddit',
  icon: 'icon-reddit',
  shUrl: 'https://www.reddit.com/web/submit?',
},
{
  key: 'Email',
  title: t('detail.email'),
  icon: 'icon-email',
},
{
  key: 'Copy',
  title: t('detail.copyText'),
  icon: 'icon-copy-link',
}];

const sharePopoverRef = ref(null);

const handlePopoverClose = () => {
  if(sharePopoverRef.value) {
    sharePopoverRef.value?.hide();
  }
};

defineExpose({ handlePopoverClose });


const source = ref('');
// const { text, copy, copied, isSupported } = useClipboard({ source });
const { copy } = useClipboard({ source });
const handleCommand = (item) => {
  const title = t('meta.socialShareContentTitle');
  // const meta = document.getElementsByTagName('meta');

  switch (item.key) {
    case 'Facebook':
      window.open(`${item.shUrl + window.location.href}?platform=facebook`);
      break;
    case 'Twitter':
      window.open(`${item.shUrl}text=${title}&url=${window.location.href}?platform=twitter`);
      break;
    case 'Reddit':
      window.open(`${item.shUrl}title=${title}&url=${window.location.href}`);
      break;
    case 'Email':
      window.location.href = `mailto:?body=${window.location.href}`;
      break;
    case 'Copy':
      copy(source.value);
      sharePopoverRef.value.hide();
      $showToast(t('detail.copySuccess'));
      break;
    default:
      break;
  }
};
onMounted(() => {
  source.value = window.location.href;
});
</script>

<style lang="scss" scoped></style>
